import { render, staticRenderFns } from "./vue-work-week-calendar.vue?vue&type=template&id=51e39e64&scoped=true"
import script from "./vue-work-week-calendar.vue?vue&type=script&lang=js"
export * from "./vue-work-week-calendar.vue?vue&type=script&lang=js"
import style0 from "./vue-work-week-calendar.vue?vue&type=style&index=0&id=51e39e64&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e39e64",
  null
  
)

export default component.exports